export default __webpack_public_path__ + "static/media/Stamp11.c3a9fafc.svg";